// No layout - standalone page
export default [];
